import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";

export const useServicePartnersQueries = () => {
  const api = useApi();
  const projectId = useProjectId();

  return {
    list: () =>
      queryOptions({
        queryKey: QUERY_KEYS.SERVICE_PARTNERS_ALL(projectId),
        queryFn: () => api.getServicepartnersV1(),
        select: (data) => commonAPIDataSelector(data).items,
      }),

    iqbiConsumption: (serviceId: string, month: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.SERVICE_PARTNER_IQBI(projectId, serviceId, month),
        queryFn: () => api.getServicepartnersIqbiConsumptionV1({ month }),
        staleTime: Infinity,
      }),

    categories: () =>
      queryOptions({
        queryKey: QUERY_KEYS.SERVICE_PARTNERS_CATEGORIES(projectId),
        queryFn: () => api.getServicepartnersCategoriesV1(),
        select: commonAPIDataSelector,
      }),

    createTypes: () =>
      queryOptions({
        queryKey: QUERY_KEYS.SERVICE_PARTNERS_CREATE_TYPES(projectId),
        queryFn: () =>
          api.getServicepartnersV1({
            returnAllowedTypes: true,
            Limit: 0,
          }),
        select: commonAPIDataSelector,
      }),

    defaultPermissions: () =>
      queryOptions({
        queryKey: QUERY_KEYS.SERVICE_PARTNERS_DEFAULT_PERMISSIONS(projectId),
        queryFn: () => api.getPermissionsDefaultServicePageV1(),
        select: commonAPIDataSelector,
      }),
  };
};
